import styled from 'styled-components'
import { ResponsiveImage } from '../ResponsiveImage/ResponsiveImage'
import { SansTitle } from '../SansTitle/SansTitle'

export const LinkContainer = styled.a`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1.2rem;
  text-decoration: none;

  &:hover {
    text-decoration: none;

    ${SansTitle} {
      text-decoration: underline;
      text-decoration-thickness: 0.1rem;
      text-underline-offset: 0.3rem;
    }
  }

  @media screen and (min-width: 768px) {
    gap: 1.6rem;
  }
`

export const ImageContainer = styled.div`
  width: 100%;

  .safari-lower-than-15 & {
    margin-bottom: 1.6rem;
    position: relative;
    padding-top: 125%;
  }
`

export const Image = styled(ResponsiveImage)`
  height: 100%;
  aspect-ratio: 4/5;
  object-fit: cover;

  .safari-lower-than-15 & {
    position: absolute;
    top: 0;
  }
`
